import React from 'react';

import CheckCircleIcon from '@atlaskit/icon/glyph/check-circle';
import SelectClearIcon from '@atlaskit/icon/glyph/select-clear';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import Toggle from '@atlaskit/toggle';

import { ContentWithIconTooltip } from '@qality/common-components/src/molecules/ContentWithIconTooltip';
import { Project } from '@qality/common-model';
import { StorageOfUniqueServices } from '@qality/common-service';

import {
  ContentWrapper,
  ProjectSettingsRowLinkStyled,
  ProjectSettingsRowStyled,
} from './ProjectSettings.row.styled';

interface StatusOfQAlityIssueTypeSetupProps {
  project: Project;
  toggleQalityTestIssueType: () => void;
}

export const StatusOfQAlityIssueTypeSetup: React.FC<StatusOfQAlityIssueTypeSetupProps> =
  ({
    project,
    toggleQalityTestIssueType,
  }: StatusOfQAlityIssueTypeSetupProps) => {
    const isPluginDisabled = !project.isPluginEnabled;
    const isIssueTypeDisabled = !project.doesGivenProjectHaveQAlityTest();

    const getTeamManagedContent = () => {
      if (isPluginDisabled) {
        return null;
      }

      return (
        <ContentWrapper>
          <ContentWithIconTooltip
            iconBefore={
              isIssueTypeDisabled ? (
                <WarningIcon
                  label='warning-icon'
                  primaryColor='var(--ds-icon-warning, var(--ds-fb-icon-warning))'
                />
              ) : (
                <CheckCircleIcon
                  label='check-icon'
                  primaryColor='var(--ds-icon-success, var(--ds-fb-icon-success))'
                />
              )
            }
          >
            <ProjectSettingsRowLinkStyled
              href={StorageOfUniqueServices.get(
                'URLService'
              ).getNextGenIssueTypeConfigUrl(project.key)}
              target='_blank'
              rel='noreferrer'
              isDisabled={isPluginDisabled}
            >
              {isIssueTypeDisabled ? 'Add issue type manually' : 'Manage'}
            </ProjectSettingsRowLinkStyled>
          </ContentWithIconTooltip>
        </ContentWrapper>
      );
    };

    const getCompanyManagedContent = () => {
      return (
        <>
          <Toggle
            size='large'
            testId={`toggle_qality_test_issue_type_${project.id}`}
            onChange={toggleQalityTestIssueType}
            isChecked={!isIssueTypeDisabled}
            isDisabled={isPluginDisabled}
          />
          {!isPluginDisabled && isIssueTypeDisabled && (
            <ContentWrapper>
              <ContentWithIconTooltip
                iconBefore={
                  <SelectClearIcon
                    label='select-clear-icon'
                    primaryColor='var(--ds-icon-warning, var(--ds-fb-icon-warning))'
                  />
                }
              >
                <span>Enable issue type</span>
              </ContentWithIconTooltip>
            </ContentWrapper>
          )}
        </>
      );
    };

    return (
      <ProjectSettingsRowStyled muted={isPluginDisabled}>
        {project.isTeamManaged()
          ? getTeamManagedContent()
          : getCompanyManagedContent()}
      </ProjectSettingsRowStyled>
    );
  };
